module.exports = __webpack_public_path__ + "img/dice-6.733f0f60.svg";